import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Avatar,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  Switch,
  Alert,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { createBlobInContainerWithName } from "src/utils/filesApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import QuestionDialog from "src/components/bingo/QuestionDialog";
import UploadFileDialog from "src/components/bingo/UploadFileDialog";

const role = localStorage.getItem("role");

export default function GameQuestionsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [rows, setRows] = useState(null);
  const [defaultRows, setDefaultRows] = useState(null);
  const [game, setGame] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCustomQuestion, setOpenCustomQuestion] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [hasTeamQuestions, setHasTeamQuestions] = useState(true);
  const [file, setFile] = useState(null);
  const [openUploadCreditsDialog, setOpenUploadCreditsDialog] = useState(false);
  const [isButtonSaveDisabled, setButtonSaveDisabled] = useState(false);
  const [checkQuestionsResult, setCheckQuestionsResult] = useState(null);

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      setGame(gameId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/games/${gameId}`)
        .then(function (response) {
          const game = response.data.game;
          axios
            .get(
              `${process.env.REACT_APP_API_BASE_URL}/admin/game/${gameId}/questions`
            )
            .then(function (response) {
              setRows(response.data.questions);
              checkQuestionsSettings(game, response.data.questions);
              setDefaultRows(response.data.questions);
              const teamQuestion = response.data.questions.find(
                (item) => item.type === "team"
              );
              if (!teamQuestion) {
                setHasTeamQuestions(false);
              }
            });
        });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const checkQuestionsSettings = (game, questions) => {
    let checkResult = [];
    for (let level of ["easy", "med", "hard"]) {
      for (let type of ["team", "player"]) {
        let count = questions.filter(
          (item) => item.level === level.toUpperCase() && item.type === type
        ).length;

        checkResult.push({
          level: level,
          type: type,
          count: count,
          expectedCount:
            game[`${level}QuestionsCount`] > 0
              ? game[`${type}QuestionsCount`]
              : 0,
        });
      }
    }
    setCheckQuestionsResult(checkResult);
    console.log("checkResult", checkResult);
  };
  const handleRevertSingleQuestionScoring = () => {
    setLoading(true);
    setOpen(null);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/score-single-question`,
        { questionId: openId, isCorrect: false }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleScoreSingleQuestionScoring = () => {
    setLoading(true);
    setOpen(null);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/score-single-question`,
        { questionId: openId, isCorrect: true }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleDeleteQuestion = () => {
    setLoading(true);
    setOpen(null);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/delete-question`,
        { questionId: openId }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleGenerateQuestions = () => {
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/generate-team-questions`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleRevertQuestionsScoring = () => {
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/revert-questions-scoring`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const uploadFiles = (event, name) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;
      console.log("name", name);
      let uploadPromises = [];
      uploadPromises.push(createBlobInContainerWithName(files[0], name));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);
          setRows([...rows]);
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const deleteGameHandler = () => {
    setLoading(true);
    setOpen(false);
    setOpenConfirm(false);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/delete-question`,
        { questionId: openId }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const requestSearch = (searchedVal) => {
    if (searchedVal.length === 0) {
      setRows([...defaultRows]);
    } else {
      const filteredRows = rows.filter((row) => {
        return (
          row.text.toLowerCase().includes(searchedVal.toLowerCase()) ||
          row.targetName.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setRows(filteredRows);
    }
  };

  const handleChangeToggle = (event) => {
    let filteredRows = rows;
    if (event.target.checked) {
      filteredRows = filteredRows.filter((row) => row.isCorrect);
    } else {
      filteredRows = defaultRows;
    }

    setRows([...filteredRows]);
    setToggle(event.target.checked);
  };
  const handleSaveCustomQuestions = (event) => {
    setLoading(true);
    if (isButtonSaveDisabled) {
      return;
    }
    setButtonSaveDisabled(true);

    const bodyFormData = new FormData();
    bodyFormData.append("file", file);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/upload/game/${game}/custom-questions`,
        bodyFormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then(function (response) {
        window.location.reload(false);
      })
      .finally(function () {
        setButtonSaveDisabled(false);
      });
  };
  const fileUpload = (file) => {
    setOpenUploadCreditsDialog(false);
    setFile(file);
  };
  const closeUploadDialog = () => {
    setOpenUploadCreditsDialog(false);
  };

  const getTeamLogo = (logoId) => {
    if (process.env.REACT_APP_LEAGUE_NAME === "nhl") {
      return `https://www-league.nhlstatic.com/images/logos/teams-current-primary-light/${logoId}.svg`;
    }
    return `${process.env.REACT_APP_API_BASE_URL}/public/teams/${logoId}.png?date=${new Date().getTime()}`;
  };
  const getPlayerLogo = (logoId) => {
    if (process.env.REACT_APP_LEAGUE_NAME === "nhl") {
      return `https://cms.nhl.bamgrid.com/images/headshots/current/168x168/${logoId}.jpg`;
    }
    return `${process.env.REACT_APP_API_BASE_URL}/public/players/${logoId}.png?date=${new Date().getTime()}`;
  };
  return (
    <>
      <Helmet>
        <title> Bingo Game Questions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Typography variant="h4" gutterBottom>
            Game Questions
          </Typography>
          {!loading &&
            process.env.REACT_APP_ALLOW_TEAM_QUESTIONS === "true" &&
            !hasTeamQuestions &&
            process.env.REACT_APP_NAME !== "olybet" && (
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:flip-2-outline" />}
                onClick={() => handleGenerateQuestions()}
                disabled={loading}
              >
                Generate Team Questions
              </Button>
            )}
          {role !== "VIEWER" && (
            <Box>
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:undo-outline" />}
                onClick={() => handleRevertQuestionsScoring()}
                disabled={loading}
                sx={{ mr: 1 }}
              >
                Rever Questions Scoring
              </Button>

              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:plus-outline" />}
                onClick={() => setOpenCustomQuestion(true)}
                disabled={loading}
                sx={{ mr: 1 }}
              >
                Create Custom Question
              </Button>

              {process.env.REACT_APP_NAME !== "olybet" ? (
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-outline" />}
                  onClick={() =>
                    navigate(`/dashboard/game/questions/create?game_id=${game}`)
                  }
                  disabled={loading}
                >
                  Create Questions
                </Button>
              ) : null}
            </Box>
          )}
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="end" mb={5}>
          <Box>
            <span>{file?.name}</span>
            {!file ? (
              <>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  onClick={() => setOpenUploadCreditsDialog(true)}
                  sx={{ mr: 1 }}
                >
                  Upload Custom Questions
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  onClick={() => setFile(null)}
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={isButtonSaveDisabled}
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  onClick={handleSaveCustomQuestions}
                >
                  Save
                </Button>
              </>
            )}
          </Box>
        </Stack>

        {checkQuestionsResult && (
          <Alert
            sx={{ marginBottom: 2 }}
            severity={
              checkQuestionsResult.find(
                (item) => item.count < item.expectedCount
              )
                ? "error"
                : "info"
            }
          >
            <Typography variant="h6" gutterBottom>
              Questions details:
            </Typography>
            {checkQuestionsResult.map((item, index) => (
              <span key={index}>
                {item.count} / {item.expectedCount} {item.level} {item.type}{" "}
                questions
                <br />
              </span>
            ))}
          </Alert>
        )}

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <TextField
                  margin="dense"
                  id="kickoff"
                  label="Search"
                  type="email"
                  fullWidth
                  variant="standard"
                  onInput={(e) => {
                    requestSearch(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon={"eva:search-outline"} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ p: 2 }}>
                <FormControlLabel
                  control={
                    <Switch checked={toggle} onChange={handleChangeToggle} />
                  }
                  label="Show correct questions"
                />
              </Box>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Text</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Level</TableCell>
                      <TableCell>Logo</TableCell>
                      <TableCell>Correct</TableCell>
                      <TableCell>Stat</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.questionId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.targetName} {row.text}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.type}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.level}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Avatar
                            alt="Logo"
                            src={
                              row.type === "team"
                                ? getTeamLogo(row.logoId)
                                : getPlayerLogo(row.logoId)
                            }
                          />
                          {`${row.logoId}.png`}
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={(event) =>
                                uploadFiles(
                                  event,
                                  row.type === "team"
                                    ? `teams/${row.logoId}.png`
                                    : `players/${row.logoId}.png`
                                )
                              }
                            />
                            <Iconify
                              icon={"eva:upload-outline"}
                              sx={{ mr: 2 }}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isCorrect ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.scoreType}
                        </TableCell>
                        {role !== "VIEWER" && (
                          <>
                            <TableCell align="right">
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={handleOpenMenu}
                                id={row.questionId}
                              >
                                <Iconify icon={"eva:more-vertical-fill"} />
                              </IconButton>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      {openCustomQuestion && (
        <QuestionDialog
          onClose={() => setOpenCustomQuestion(false)}
          gameId={game}
        />
      )}

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete question?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All cards with this question would effected.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => deleteGameHandler(true)} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/**
         * 
         * <MenuItem
          sx={{ color: "error.main" }}
          onClick={() => setOpenConfirm(true)}
        >
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
         */}

        <MenuItem onClick={() => handleRevertSingleQuestionScoring()}>
          <Iconify icon={"eva:close-circle-outline"} sx={{ mr: 2 }} />
          Unscore
        </MenuItem>
        <MenuItem onClick={() => handleScoreSingleQuestionScoring()}>
          <Iconify icon={"eva:checkmark-circle-2-outline"} sx={{ mr: 2 }} />
          Score
        </MenuItem>
        <MenuItem onClick={() => handleDeleteQuestion()}>
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>

      <UploadFileDialog
        open={openUploadCreditsDialog}
        onSuccessHandler={(file) => fileUpload(file)}
        onClose={closeUploadDialog}
      />
    </>
  );
}
